import Marquee from "react-fast-marquee";

const items = [
    "Streams daily @ 11 AM EST",
    "From ooll56 to itz_ool",
    "Chat-driven · Community-first",
    "Variety streamer · Twitch partner-bound",
    "Road to Top 50",
    "Run by the mods: realcpat · tanoshark · rexynz04",
    "Pull up. Drop a follow.",
];

export const MarqueeBar = () => {
    return (
        <div
            className="relative border-y border-white/[0.06] bg-black/40 overflow-hidden"
            data-testid="marquee-bar"
        >
            <Marquee speed={40} pauseOnHover gradient gradientColor="#060608" gradientWidth={60}>
                {items.map((text, idx) => (
                    <div
                        key={idx}
                        className="flex items-center gap-4 px-8 py-3.5 text-white/55"
                    >
                        <span className="h-1 w-1 rounded-full bg-brand-cyan/60" />
                        <span className="text-xs uppercase tracking-[0.18em] whitespace-nowrap font-mono">{text}</span>
                    </div>
                ))}
            </Marquee>
        </div>
    );
};
